import TeamPersonAdd from '@/screens/TeamPersonAdd';

export default function PrivateTeamTeamIdPersonAddIndexRoute() {
  return <TeamPersonAdd />;
}
